import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6dd944ae&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd944ae')) {
      api.createRecord('6dd944ae', component.options)
    } else {
      api.reload('6dd944ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6dd944ae&", function () {
      api.rerender('6dd944ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/venueBooking/venueBasicManage/venueManage/index.vue"
export default component.exports